
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Bookpunetokohlapurcab() {



    const cardData =
    {
        keyword: 'Pune to Kolhapur Taxi Services',
        heading: 'S9 Travels: Pune to Kolhapur Taxi Services',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable taxi services from Pune to Kolhapur. Whether you are visiting for a spiritual experience, historical exploration, or to enjoy the local cuisine, our well-maintained fleet and professional drivers ensure a smooth and hassle-free journey. Kolhapur is approximately 230 km from Pune, and the journey takes around 4 to 5 hours by road. Enjoy a safe and comfortable ride with our top-notch amenities and customer-centric service.',

        top: 'Top Places to Visit in Kolhapur with S9 Travels',

"topPlaces": [
    {
        "title": "Mahalakshmi Temple",
        "description": "Kolhapur is known for the revered Mahalakshmi Temple, dedicated to Goddess Lakshmi. This temple is one of the most famous pilgrimage sites in Maharashtra and is visited by thousands of devotees every year. The temple's grand architecture and spiritual significance make it a must-visit for pilgrims."
    },
    {
        "title": "Panhala Fort",
        "description": "Located around 20 km from Kolhapur, Panhala Fort is an important historical site with stunning views of the surrounding hills. The fort has a rich history and is associated with the Maratha Empire. It offers a peaceful retreat and a chance to explore its ruins, historical structures, and scenic landscapes."
    },
    {
        "title": "Rankala Lake",
        "description": "Rankala Lake is one of Kolhapur's most popular attractions. The lake, surrounded by temples and beautiful parks, offers a serene environment for picnics, boating, and leisurely walks. The sunsets here are stunning, making it an ideal place for relaxation."
    },
    {
        "title": "Chhatrapati Shahu Museum",
        "description": "Located in the heart of Kolhapur, the Chhatrapati Shahu Museum showcases the history and culture of the region. The museum is housed in a grand palace and displays artifacts related to Kolhapur’s royal heritage, including sculptures, paintings, and antiques."
    },
    {
        "title": "New Palace",
        "description": "The New Palace in Kolhapur is an architectural marvel and a prime example of the region’s royal heritage. Built in the 19th century, the palace is a mix of traditional and contemporary design. Visitors can explore its royal rooms, gardens, and the nearby museum that exhibits the history of the Kolhapur dynasty."
    },
    {
        "title": "Kopeshwar Temple",
        "description": "Situated in the town of Khidrapur, about 45 km from Kolhapur, the Kopeshwar Temple is dedicated to Lord Shiva and is known for its beautiful and intricate carvings. The temple's historical significance and peaceful atmosphere make it a must-visit for history and architecture enthusiasts."
    },
    {
        "title": "Jyotiba Temple",
        "description": "Located on a hilltop about 20 km from Kolhapur, Jyotiba Temple is dedicated to Lord Jyotiba. The temple offers magnificent views of the surrounding region and is a popular pilgrimage site. The temple’s location provides a serene and spiritual atmosphere."
    },
    {
        "title": "Sahyadri Mountains",
        "description": "The Sahyadri mountain range surrounding Kolhapur offers multiple trekking opportunities, nature walks, and scenic viewpoints. It’s ideal for adventure enthusiasts and nature lovers who want to explore the lush forests, waterfalls, and tranquility of the region."
    },
    {
        "title": "Maharaja's Palace (Shahu Maharaj Wada)",
        "description": "This historical palace, built by the Maratha rulers, is an architectural gem located in the heart of Kolhapur. The palace houses numerous artifacts and artworks that showcase the royal history of Kolhapur. It’s a great place for history buffs and those interested in the region's past."
    },
    {
        "title": "Kolhapuri Chappal Market",
        "description": "Kolhapur is famous for its traditional leather sandals known as 'Kolhapuri Chappals.' A visit to the local markets, such as the Laxmi Market, will give you the chance to shop for these famous sandals, along with local handicrafts, traditional jewelry, and souvenirs."
    }
],

"services": [
  {
    "name": "Pune to Kolhapur Taxi",
    "description": "S9 Travels offers comfortable and reliable taxi services for your journey from Pune to Kolhapur. Whether you're traveling for business, leisure, or religious purposes, enjoy a smooth and hassle-free ride. Book your Pune to Kolhapur taxi today!"
  },
  {
    "name": "Pune to Kolhapur Cab Service",
    "description": "Choose S9 Travels for a professional and reliable cab service from Pune to Kolhapur. Our experienced drivers and well-maintained vehicles ensure a comfortable, safe, and enjoyable journey every time."
  },
  {
    "name": "Pune to Kolhapur One-Way Taxi",
    "description": "S9 Travels offers affordable one-way taxi services from Pune to Kolhapur. Travel directly to your destination with a convenient and comfortable ride. No return hassle, just a smooth journey to Kolhapur."
  },
  {
    "name": "Pune to Kolhapur Round Trip",
    "description": "For a round trip from Pune to Kolhapur, S9 Travels offers flexible and convenient options. Whether for business or leisure, our round-trip service ensures that your journey is stress-free, timely, and comfortable."
  },
  {
    "name": "Pune to Kolhapur Cab Fare",
    "description": "S9 Travels provides transparent and competitive taxi fares for your Pune to Kolhapur journey. We ensure you get the best value without any hidden charges. Contact us for an accurate fare estimate for your trip."
  },
  {
    "name": "Pune to Kolhapur Car Rental",
    "description": "Looking to rent a car for your trip from Pune to Kolhapur? S9 Travels offers flexible car rental services, allowing you to travel at your own pace. Choose from a variety of vehicles that best suit your needs and preferences."
  },
  {
    "name": "Pune to Kolhapur Taxi Booking",
    "description": "Booking a taxi from Pune to Kolhapur is easy with S9 Travels. We offer flexible booking options, whether you prefer to book online or over the phone, ensuring a hassle-free experience for your journey."
  },
  {
    "name": "Pune to Kolhapur Private Taxi",
    "description": "For a private and personalized experience, book a private taxi with S9 Travels. Our private taxi service offers the comfort, privacy, and flexibility you need for your journey from Pune to Kolhapur, ensuring a smooth ride."
  },
  {
    "name": "Pune to Kolhapur Efficient Taxi",
    "description": "S9 Travels offers Efficient Taxi services for those looking for a budget-friendly travel option. Share the ride with others while enjoying a comfortable, convenient, and affordable journey from Pune to Kolhapur."
  }
],


"tableData": [
  ["Book Pune To Kolhapur Taxi", "Book Pune To Kolhapur Cab Service"],
  ["Book Pune To Kolhapur One-Way Taxi", "Book Pune To Kolhapur Round Trip"],
  ["Book Pune To Kolhapur Cab Fare", "Book Pune To Kolhapur Car Rental"],
  ["Book Pune To Kolhapur Taxi Booking", "Book Pune To Kolhapur Private Taxi"],
  ["Book Pune To Kolhapur Efficient Taxi"]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of punctuality when traveling from Pune to Kolhapur. Whether you're visiting for business, religious purposes, or leisure, our drivers ensure timely pickups and drop-offs, making your trip smooth and hassle-free."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We provide a range of comfortable vehicles for your journey to Kolhapur. Our well-maintained cars, equipped with air conditioning and spacious seating, ensure a relaxing and pleasant ride throughout your trip."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced in handling long-distance travel and are familiar with the best routes to Kolhapur. Their professionalism ensures a safe, smooth, and comfortable journey, so you can enjoy your trip with peace of mind."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive pricing for your Pune to Kolhapur trip. We believe in transparency, so there are no hidden charges. You will receive a clear breakdown of costs upfront, allowing you to plan your trip without any surprises."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our top priority. Our vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking, ensuring that you have a secure and comfortable journey at all times."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels operates around the clock. Whether you're planning an early morning trip or a late-night return, our services are available at any time to meet your travel needs. Our customer service team is also available to assist you 24/7."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking a Pune to Kolhapur cab with S9 Travels is simple and quick. You can book online via our website or mobile app, or contact our customer service team for any assistance in making your reservation."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you're traveling for a religious trip, sightseeing, or a business visit, we offer customized travel packages to suit your specific needs. Let us know your preferences, and we’ll make sure your trip is tailored for comfort and convenience."
  }
]











    }




    const faqData = [
        [
          {
            question: 'How can I book a Pune to Kolhapur cab with S9 Travels?',
            answer: 'Booking is easy! You can reserve your cab through our website, mobile app, or by contacting our customer service team for personalized booking assistance.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, all our drivers are highly experienced in long-distance travel and are familiar with the best routes to Kolhapur, ensuring a smooth and safe journey.',
          },
          {
            question: 'What types of vehicles are available for Pune to Kolhapur travel?',
            answer: 'We offer a variety of well-maintained vehicles, including sedans, SUVs, and premium cars, all designed for comfort and safety during long trips.',
          },
          {
            question: 'How do I pay for my Pune to Kolhapur cab rental?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments via our app, making it convenient for you to pay.',
          },
          {
            question: 'Can I book a round trip from Pune to Kolhapur?',
            answer: 'Yes, we offer round-trip services. Simply provide us with your return details, and we’ll ensure that everything is arranged for a smooth and hassle-free return.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges, like waiting time or detours, will be clearly communicated to you upfront, ensuring complete transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Kolhapur?',
            answer: 'Yes, we offer sightseeing tours in Kolhapur, including visits to the famous Mahalakshmi Temple, Rankala Lake, and other local attractions. Our experienced drivers will guide you through the best spots.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Kolhapur cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have more luggage or special requirements, please inform us during the booking process, and we’ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate travel between Pune and Kolhapur?',
            answer: 'Yes, we provide corporate travel services for business trips, group travel, or team outings between Pune and Kolhapur. We ensure reliable and punctual services for corporate clients.',
          },
          {
            question: 'Why should I choose S9 Travels for Pune to Kolhapur travel?',
            answer: 'S9 Travels guarantees a reliable, comfortable, and affordable journey. With our professional drivers, well-maintained vehicles, and excellent customer service, we ensure a smooth and stress-free trip every time.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Nitin Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],  
          text: '“I had a wonderful experience traveling to Kolhapur with S9 Travels. The vehicle was clean and comfortable, and the driver was polite and professional. The journey was smooth, and I felt safe throughout the trip. Highly recommend!”',
        },
        {
          name: 'Mrs. Shubha Patil',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],  
          text: '“We took a family trip to Kolhapur, and S9 Travels made the journey very comfortable. The driver was knowledgeable, and the vehicle was spacious and clean. We had a great time and will definitely book with them again!”',
        },
      ];
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Book Pune To Kolhapur Cab",
        "description": "Book Pune To Kolhapur taxi services, one-way taxi, round trip, private taxi, Efficient Taxi, and car rental with S9 Travels. Choose from affordable Pune to Kolhapur cab booking options, including luxury taxis, for a comfortable and safe journey.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      
      


    return (
        <div>
          <Helmet>
        <title>Book Pune To Kolhapur Cab | Affordable Taxi & Car Rental Services | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune To Kolhapur taxi, one-way taxi, round trip, private taxi, Efficient Taxi, and car rental services with S9 Travels. Get the best fares for Pune to Kolhapur cab booking, ensuring a safe, comfortable, and affordable ride." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/6.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bookpunetokohlapurcab;